import actionsTypes from "../constants/ActionTypes";

export const actions = {
    clickMenuOpen: () => ({
        type: actionsTypes.CLICK_OPEN_MENU,
    }),
    setUrlProfilePhoto: (urlProfilePhoto) => ({
        type: actionsTypes.URL_PROFILE_PHOTO,
        urlProfilePhoto: urlProfilePhoto,
    }),
    setPublicCode: (publicCode) => ({
        type: actionsTypes.PUBLIC_CODE,
        publicCode: publicCode,
    }),
    setCurrentCompany: (company) => ({
        type: actionsTypes.SET_CURRENT_COMPANY,
        company: company,
    }),
    setCompanies: (companies) => ({
        type: actionsTypes.SET_COMPANIES,
        companies: companies,
    }),
    setUserRoles: (isAdmin, isOperator) => ({
        type: actionsTypes.SET_USER_ROLES,
        isAdmin: isAdmin,
        isOperator: isOperator,
    }),
};

export const clickMenuOpen = value => ({
    type: actionsTypes.CLICK_OPEN_MENU,
    newValue: value
});

export const setCurrentCompany = (company) => ({
    type: actionsTypes.SET_CURRENT_COMPANY,
    company: company,
});

export const setCompanies = (companies) => ({
    type: actionsTypes.SET_COMPANIES,
    companies: companies,
});

export const setUserRoles = (isAdmin, isOperator) => ({
    type: actionsTypes.SET_USER_ROLES,
    isAdmin: isAdmin,
    isOperator: isOperator,
});

